import Column from "./Column";
import React from "react";

function ActivationFrame({ data }){
    const url = `${process.env.GATSBY_SF_DOMAIN}/PublicActivationRequest`;
    return (
    <Column size="4">
    <iframe height="600"
     src={url} title="Activation"/>

    </Column>
    );
}
export default ActivationFrame;
